module.exports = __webpack_public_path__ + "assets/Track-Pause.e7c69580.svg";